module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet data = {}, attributes = {}\nif(rowResourceData){\ndata = rowResourceData\nattributes = data.attributes || {}\n}\nconst status = attributes.externalApiStatus || 'none'\nlet content = ''\nif(status === 'none') {\ncontent = '-'\n} else {\nlet ts = false\nif(attributes.externalApiTS){\nts = utils.moment(attributes.externalApiTS).format('DD.MM.YYYY HH:mm')\n}\ncontent = storage.__(`productAdditionalInformation.table.externalApiStatus.${status}`, { ts })\n}\n%><div title=\"<%= content %>\"><%\n%><%= content %><%\n%></div>"
  , __filename = "components/templates/mblx/products/additionalInformation/tableFields/externalApiStatusSummary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let data = {}, attributes = {}
if(rowResourceData){
data = rowResourceData
attributes = data.attributes || {}
}
const status = attributes.externalApiStatus || 'none'
let content = ''
if(status === 'none') {
content = '-'
} else {
let ts = false
if(attributes.externalApiTS){
ts = utils.moment(attributes.externalApiTS).format('DD.MM.YYYY HH:mm')
}
content = storage.__(`productAdditionalInformation.table.externalApiStatus.${status}`, { ts })
}

    ; __line = 18
    ; __append("<div title=\"")
    ; __append(escapeFn( content ))
    ; __append("\">")
    ; 

    ; __line = 19
    ; __append(escapeFn( content ))
    ; 

    ; __line = 20
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mblx/products/additionalInformation/tableFields/externalApiStatusSummary.ejs

}